// extracted by mini-css-extract-plugin
module.exports = {"declinePage":"style_declinePage__2CMVz","warningMessage":"style_warningMessage__1E_Cc","icon":"style_icon__1HAar","title":"style_title__2WVlY"};